import moment from 'moment';
import { dateFormat } from '../../../../../constants';
import { getStopApi } from '../../../../../services/StopApi/StopApi';

export const getPrintableAlert = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    return response;
  }).catch((e) => alert(e));
};
